import React from "react";
import { Link } from "react-router-dom";
import DIODENLASER from '../assets/laser.jpeg';
import AQUAFACIAL from '../assets/aqua.jpeg';
import MICRONEEDLING from '../assets/micro.jpeg';
import BBGLOW from '../assets/licht.jpeg';
import WIMPERNLIFTING from '../assets/lifting.jpeg';
import BROWLIFTING from '../assets/brows.jpeg';
import SALON from '../assets/background.jpeg';
import DRGRANDEL from '../assets/skincare.jpeg';

const Home: React.FC = () => {
  return (
    <div className="bg-[#FAF7F2] min-h-screen flex flex-col">

      {/* ---------------- Hero Section ---------------- */}
      <section className="w-full h-[100vh] relative flex flex-col justify-center items-center text-center px-6">

        {/* Hintergrundvideo */}
        <video
           src='/video_1.mp4'
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >        </video>

        {/* Weiches Overlay */}
        <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

        {/* Content */}
        <div className="relative z-10 max-w-3xl">
          <h1 className="text-5xl md:text-6xl font-light tracking-wide text-white">
            Willkommen bei 
          </h1>
          <h1 className="text-5xl md:text-6xl font-light tracking-wide text-white">
            Beautique Mariam
          </h1>

          <p className="mt-6 text-lg md:text-xl text-white">
            Exklusive Behandlungen für dein Wohlbefinden – stilvoll, elegant und professionell.
          </p>

          <div className="mt-10 flex gap-6 justify-center">
            <Link
              to="/kontakt"
              className="px-8 py-3 text-white bg-[#C7B9A5] hover:bg-[#b6a894] transition rounded-full shadow-md"
            >
              Termin Buchen
            </Link>

            <Link
              to="/Service"
              className="px-8 py-3 bg-white border border-[#C7B9A5] text-[#7A6E62] hover:bg-[#f3eee7] transition rounded-full shadow-md"
            >
              Leistungen
            </Link>
          </div>
        </div>
      </section>

      {/* ---------------- Erweiterte Info Section ---------------- */}
      <section className="px-6 py-20 max-w-6xl mx-auto text-center">
        
        <h2 className="text-3xl font-light text-[#7A6E62]">
          Unsere Expertise
        </h2>
        
        <p className="mt-4 text-[#8C8378] text-lg leading-relaxed max-w-3xl mx-auto">
          Wir kombinieren moderne Beauty-Techniken mit hochwertigen Produkten
          und einer entspannenden Atmosphäre – für Ergebnisse, die deine natürliche
          Schönheit unterstreichen.
        </p>

        {/* Grid mit Bildern */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 ">

          {/* Card 1 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <div className="inset-0 bg-black/80 backdrop-blur-s">
                <img 
                src={ DIODENLASER }
                alt="Behandlung 1"
                className="w-full h-56 object-cover"
                />
            </div>
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">Diodenlaser - dauerhafte Haarentfernung</h3>
              <p className="text-[#8C8378] mt-2 text-sm">
                Unser 4-Wellenlängen Ice-Diodenlaser arbeitet mit einem eingebauten Kühlsystem, welches die Haut kurzzeitig betäubt, wodurch das Schmerzempfinden stark gesenkt wird und die Behandlung so viel angenehmer macht. Dies ermöglicht eine nahezu schmerzfreie Laser-Sitzung.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <img 
              src={ AQUAFACIAL}
              alt="Brow Lifting"
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">Aquafacial</h3>
              <p className="text-[#8C8378] mt-2 text-sm">
                Das Aquafacial eignet sich bei verschiedenen Hautproblemen wie einer unreinen Haut, Akne oder Narben, bei Pigmentflecken, einer Hyperpigmentierung oder wenn die Haut stark gestresst und gerötet ist. Sie reduziert ebenfalls sichtbare Linien und Falten und regt die Kollagenbildung an.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <img 
              src={ DRGRANDEL }
              alt="Entspannung"
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">Gesichtsbehandlungen by dr. Grandel</h3>
              <p className="text-[#8C8378] mt-2 text-sm">
                Wir arbeiten ausschließlich mit den hochwertigen Produkten von Dr. Grandel. Die Marke steht seit Jahrzehnten für professionelle Qualität, moderne Hautpflegekonzepte und spürbare Ergebnisse. Jede Behandlung wird individuell auf die Bedürfnisse deiner Haut abgestimmt - für ein gepflegtes, frisches und gesund aussehendes Hautbild.
              </p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <img 
              src={ BROWLIFTING }
              alt="Entspannung"
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">Brow-Lifting</h3>
              <p className="text-[#8C8378] mt-2 text-sm">
                Durch das Brow-Lifting bekommen wir selbst die störrischsten Augenbrauen unter Kontrolle und verleihen schmalen oder auch überzupften Augenbrauen ein tolles Volumen.
              </p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <img 
              src={ WIMPERNLIFTING }
              alt="Entspannung"
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">Wimpernlifting</h3>
              <p className="text-[#8C8378] mt-2 text-sm"> 
                Bei unserem Wimpernlifting erhältst du einen atemberaubenden natürlichen Augenaufschlag. Passend zu deiner Augenform und deinen Wimpern, bringen wir deine Augen zum strahlen.
              </p>
            </div>
          </div>

          {/* Card 6 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <img 
              src={ MICRONEEDLING }
              alt="Entspannung"
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">Microneedling</h3>
              <p className="text-[#8C8378] mt-2 text-sm">
                Das Microneedling wird eingesetzt, um eine Hautstraffung zu erzielen, Falten zu reduzieren und Narben optisch zu lindern. Bei der Anwendung entstehen kleine Microverletzungen durch sehr dünne Nadeln. Dadurch werden die natürlichen Selbstheilungsprozesse der Haut angeregt, so dass sie sich effektiv regeneriert und ihre Struktur deutlich verbessert.
              </p>
            </div>
          </div>

          {/* Card 7 */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <img 
              src={ BBGLOW }
              alt="Entspannung"
              className="w-full h-56 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl text-[#7A6E62] font-light">BB Glow</h3>
              <p className="text-[#8C8378] mt-2 text-sm">
                Die BB Glow Anwendung ist ein effektives Anti-Aging und Hautaufhellungs-Treatment, das mittels Nano-Needling ein spezielles Serum in die Haut einführt. Es verfeinert das Hautbild, reduziert Hyperpigmentierung und schenkt deinem Teint einen schönen, strahlenden Glow.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Sticky Pfeil unten */}
      <div className="sticky bottom-4 flex justify-center">
        <a href="#next-section" className="animate-bounce">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 text-gray-800"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default Home;
